import type { PaymentType } from './index';

/**
 * Only the fields this helper reads, so callers can pass saved payment methods from queries that
 * don't fetch the rest of the payment method details.
 */
type SavedPaymentMethodBrand = Readonly<{ type: PaymentType | undefined; brand?: string }>;

const STRIPE_BRAND_MAP: Record<string, string> = {
	amex: 'American Express',
	diners: 'Diners Club',
	discover: 'Discover',
	jcb: 'JCB',
	mastercard: 'MasterCard',
	unionpay: 'UnionPay',
	visa: 'Visa',
	unknown: 'Unknown',
};

export function getStripeCardDisplayName(
	cardType: string | undefined,
	savedPaymentMethods: readonly SavedPaymentMethodBrand[] | undefined,
	usingSavedPaymentMethod: boolean,
	selectedPaymentType: PaymentType,
): string {
	if (cardType) {
		return STRIPE_BRAND_MAP[cardType] || cardType;
	}
	if (usingSavedPaymentMethod && selectedPaymentType === 'creditCard') {
		const savedBrand =
			savedPaymentMethods?.find((paymentMethod) => paymentMethod.type === 'creditCard')?.brand || 'unknown';
		return STRIPE_BRAND_MAP[savedBrand] || savedBrand;
	}

	return 'Unknown';
}
